import { type PendingDecision } from './confirmationRows.types';

const keyFor = (corporationId: number, fiscalYear: number | null): string =>
  `commenda:pending-confirmations:${corporationId}:${fiscalYear ?? 'all'}`;

export const readPendingConfirmations = (
  corporationId: number,
  fiscalYear: number | null
): Record<string, PendingDecision> => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(
      keyFor(corporationId, fiscalYear)
    );
    return raw ? (JSON.parse(raw) as Record<string, PendingDecision>) : {};
  } catch {
    return {};
  }
};

export const writePendingConfirmations = (
  corporationId: number,
  fiscalYear: number | null,
  pending: Record<string, PendingDecision>
): void => {
  if (typeof window === 'undefined') return;
  try {
    const key = keyFor(corporationId, fiscalYear);
    if (Object.keys(pending).length === 0)
      window.sessionStorage.removeItem(key);
    else window.sessionStorage.setItem(key, JSON.stringify(pending));
  } catch {
    // best-effort — sessionStorage may be unavailable (private mode / SSR).
  }
};

export const clearPendingConfirmations = (
  corporationId: number,
  fiscalYear: number | null
): void => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(keyFor(corporationId, fiscalYear));
  } catch {
    // best-effort
  }
};
